import { ofType } from "redux-observable";
import { guard } from "../guards/guard";
import { TypeActionBuyWithGold } from "./actionBuyWithGold";
import { checkPlayerHasEnoughGold } from "./checkPlayerHasEnoughGold";
import { pathNotEnoughGold } from "./pathNotEnoughGold";
import { pathRequestBuyWithGold } from "./pathRequestBuyWithGold";
export var epicBuyWithGoldBeginProcess = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuyWithGold.BeginProcess), guard(state$, deps, pathRequestBuyWithGold)([checkPlayerHasEnoughGold(pathNotEnoughGold)]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/buy-with-gold/epicBuyWithGoldBeginProcess.ts
// module id = 1788
// module chunks = 3